import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
};

export const possDownload = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.DOWNLOAD_POSS_FILE_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOAD_POSS_FILE_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);
      
      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.DOWNLOAD_POSS_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
